import React from "react";

export default function IndexSectionTestimonials5() {
  return (
    <React.Fragment>
      <>
        <section
          className="relative pt-24 pb-24 lg:pb-20 lg:pt-32 overflow-hidden"
          id="voice"
        >
          <img
            className="absolute top-0 left-0"
            src="saturn-assets/images/testimonials/blue-light.png"
            alt
          />
          <img
            className="absolute top-0 right-0"
            src="saturn-assets/images/testimonials/orange-light.png"
            alt
          />
          <div className="relative container px-4 mx-auto">
            <div className="max-w-7xl mx-auto">
              <div className="max-w-xl mb-24 mx-auto text-center">
                <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">
                  VOICE
                </span>
                <h1 className="font-heading text-4xl xs:text-6xl font-bold text-gray-900 mb-6">
                  <span>お客様の声</span>
                </h1>
              </div>
            </div>
          </div>
          <div className="relative" style={{ height: 600 }}>
            <div className="overflow-hidden h-full">
              <div className="absolute left-1/2 transform -translate-x-1/2">
                <div
                  className="flex transition-transform duration-500 ease-in-out -m-5"
                  style={{ transform: "translateX(-0px)" }}
                >
                  <div className="flex-shrink-0 h-full w-full p-5">
                    <div className="flex mb-8 justify-center">
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="saturn-assets/images/testimonials/avatar-group-3.png"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                小野寺 真優
                              </span>
                              <span className="block text-sm text-gray-500">
                                カスタマーサービス
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            顧客アンケート収集と自動集計が連動。QR読み取りだけでデータ化され、分析工数が半減です。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-2.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                桜井 美音
                              </span>
                              <span className="block text-sm text-gray-500">
                                生産管理部門
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            Googleスプレッドシートと自動同期し、在庫確認作業が8割削減。ミスも激減して助かっています。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-3.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                高橋 優斗
                              </span>
                              <span className="block text-sm text-gray-500">
                                イベント制作会社
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            イベント受付でQR読み取り速度が向上。スタッフの負荷が減り、参加者の待ち時間も解消できました。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-4.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                山岸 千佳
                              </span>
                              <span className="block text-sm text-gray-500">
                                社内IT部門
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            スマホでQRスキャンでき、既存ツールと連携可能です。月額固定で予算管理が楽になりました。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex mb-15 justify-center">
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-5.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                黒川 蓮
                              </span>
                              <span className="block text-sm text-gray-500">
                                社内IT部門
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            定額制でコストパフォーマンス抜群。他社比3割安く、機能面でも遜色ない点が魅力です。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-6.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                山岸 千佳
                              </span>
                              <span className="block text-sm text-gray-500">
                                学習塾
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            初期費用0円で導入しやすく、操作画面も直感的。中小企業のデジタル化推進に最適です。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="/saturn-assets/images/review-7.avif"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                篠原 龍之介
                              </span>
                              <span className="block text-sm text-gray-500">
                                物流管理部門
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            物流現場でQR管理を導入。スマホで荷物追跡が即時反映され、配送ミスがほぼなくなりました。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-full max-w-sm flex-shrink-0 mr-8">
                        <div className="p-6 bg-white rounded-4xl shadow-lg">
                          <div className="flex mb-6 items-center">
                            <img
                              className="block w-15 h-15 rounded-full"
                              src="saturn-assets/images/testimonials/avatar-group-1.png"
                              alt
                            />
                            <div className="ml-5">
                              <span className="block text-xl font-semibold leading-none">
                                Brooklyn Simmons
                              </span>
                              <span className="block text-sm text-gray-500">
                                デザイン会社
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-gray-900 mb-6">
                            操作マニュアル不要なシンプル設計。パート職員でも即日使いこなせ、教育コストが節約できました。
                          </p>
                          <div className="flex items-center">
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                            <img
                              className="block mr-1.5"
                              src="saturn-assets/images/testimonials/star.svg"
                              alt
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="px-5">
              <div className="relative flex items-center justify-center">
                <button className="bg-orange-900 inline-block mr-1 w-7 h-1 bg-orange-900" />
                <button className="inline-block mr-1 w-7 h-1 bg-gray-400 hover:bg-orange-300" />
                <button className="inline-block w-7 h-1 bg-gray-400 hover:bg-orange-300" />
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
